import { render, staticRenderFns } from "./EachCountryTabContent.vue?vue&type=template&id=dd205c06&scoped=true&"
import script from "./EachCountryTabContent.vue?vue&type=script&lang=js&"
export * from "./EachCountryTabContent.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryTabContent.vue?vue&type=style&index=0&id=dd205c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd205c06",
  null
  
)

export default component.exports